<template>
    <span class="label bg-green" v-if="unreadNotificationsCountLocal > 0">{{ unreadNotificationsCountLocal }}</span>
</template>

<script>
    export default {
        props: ['unreadNotificationsCount'],
        data: function () {
            return {
                unreadNotificationsCountLocal: null,
            }
        },
        mounted() {
            this.unreadNotificationsCountLocal = this.unreadNotificationsCount;
            Event.$on('notificationRead', (unreadNotificationsCount, notificationId, infoMessage) => {
                this.setUnreadNotifications(unreadNotificationsCount);
            });
            
            // Listen for real-time task completion events (with fallback)
            if (window.Echo && typeof window.Echo.private === 'function' && window.Laravel && window.Laravel.user) {
                try {
                    const userId = window.Laravel.user.id;
                    window.Echo.private(`user.${userId}`)
                        .listen('.task.completed', (e) => {
                            console.log('✅ Task completed:', e);
                            // Show toast notification for task completion
                            if (typeof toastr !== 'undefined') {
                                toastr.success(`${e.user.name} ha completato il task "${e.task.title}"`, 'Task Completato');
                            }
                        });
                    console.log('✅ WebSocket listener registered for task completion');
                } catch (error) {
                    console.error('❌ Failed to register WebSocket listener:', error);
                }
            } else {
                console.log('ℹ️ WebSocket not available - task notifications disabled');
            }
        },
        methods: {
            setUnreadNotifications(unreadNotificationsCountLocal) {
                this.unreadNotificationsCountLocal = unreadNotificationsCountLocal;
            }
        },
    }
</script>